import { render, staticRenderFns } from "./UpDown.vue?vue&type=template&id=59a23f9e&scoped=true"
import script from "./UpDown.vue?vue&type=script&lang=js"
export * from "./UpDown.vue?vue&type=script&lang=js"
import style0 from "./UpDown.vue?vue&type=style&index=0&id=59a23f9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59a23f9e",
  null
  
)

export default component.exports